define([
  "marionette",
  "messaging/messenger",
  "modules/tasks/tasksModel",
  "./template/taskScheduleTemplate.html",
], function (Marionette, Messenger, TaskModel, TaskScheduleTemplate) {
  "use strict";

  const TaskScheduleView = {};

  TaskScheduleView.view = Marionette.ItemView.extend({
    template: TaskScheduleTemplate,
    onRender: function () {
      const dateToday = new Date();
      const expirationDateEl = this.$el.find("#expirationDate");
      const format = Messenger.reqres.request("get:datepicker:date:format");
      const langCode = Messenger.reqres.request("get:interface:language");
      expirationDateEl.datepicker({
        dateFormat: format,
        language: langCode,
        minDate: dateToday,
        defaultDate: "+1y",
      });

      this.$el.i18n();
    },
    events: {
      "change #scheduleTask": function () {
        const isChecked = this.$el.find("#scheduleTask").prop("checked");
        // If the checkbox is checked, show and enable the interval select and expire check box.
        // Otherwise, hide and disable them.
        if (isChecked) {
          this.$el.find(".task-interval-row").removeClass("hidden");
          this.$el.find(".task-expire-row").removeClass("hidden");
        } else {
          this.$el.find(".task-interval-row").addClass("hidden");
          this.$el.find(".task-expire-row").addClass("hidden");
        }
        this.$el.find("#scheduleInterval").prop("disabled", !isChecked);
        this.$el.find("#scheduleExpire").prop("disabled", !isChecked);
        this.trigger("change:task:is:scheduled", isChecked);
      },
      "change #scheduleInterval": function () {
        const intervalId = this.$el.find("#scheduleInterval").val();
        this.trigger("change:task:schedule:interval", intervalId);
      },
      "change #scheduleIntervalAmount": function () {
        const intervalAmount = this.$el.find("#scheduleIntervalAmount").val();
        this.trigger("change:task:schedule:intervalAmount", +intervalAmount);
      },
      "change #scheduleExpire": function () {
        const isChecked = this.$el.find("#scheduleExpire").prop("checked");
        const expirationDateEl = this.$el.find("#expirationDate");
        let expirationDate = expirationDateEl.datepicker("getDate");
        // If the checkbox is checked, show and enable expiration date picker.
        // Otherwise, hide and disable it.
        if (isChecked) {
          expirationDateEl.prop("disabled", false).removeClass("hidden");
          if (!expirationDate) {
            const today = new Date();
            expirationDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
            expirationDateEl.datepicker("setDate", expirationDate);
          }
        } else {
          expirationDateEl.val("").prop("disabled", true).addClass("hidden");
        }
        const expirationDateUtc = Messenger.reqres.request("to:dateUtc", expirationDate);
        this.trigger("change:task:has:expiration", isChecked, expirationDateUtc);
      },
      "change #expirationDate": function () {
        const isChecked = this.$el.find("#scheduleExpire").prop("checked");
        const expirationDate = this.$el.find("#expirationDate").datepicker("getDate");
        const expirationDateUtc = Messenger.reqres.request("to:dateUtc", expirationDate);
        this.trigger("change:task:has:expiration", isChecked, expirationDateUtc);
      },
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date", date);
      },
    },
    getExpirationDate: function () {
      const isChecked = this.$el.find("#scheduleExpire").prop("checked");
      if (!isChecked) {
        return null;
      }
      const expirationDate = this.$el.find("#expirationDate").datepicker("getDate");
      return Messenger.reqres.request("to:dateUtc", expirationDate);
    },
    getInterval: function () {
      return +this.$el.find("#scheduleInterval").val() || TaskModel.INTERVAL.NONE;
    },
    getIntervalAmount: function () {
      const intervalAmount = this.$el.find("#scheduleIntervalAmount").val();
      if (intervalAmount) {
        return +intervalAmount;
      }
      return TaskModel.DEFAULT_INTERVAL_AMOUNT;
    },
    isScheduled: function () {
      return this.$el.find("#scheduleTask").prop("checked");
    },
  });

  return TaskScheduleView;
});
